/**
 * Glass reminder checkbox in the cart drawer.
 *
 * Loaded from layout/theme.liquid rather than inline in the snippet, because the
 * drawer's contents live inside <template id="deferred"> and are injected as an
 * HTML string. Scripts inside that markup never execute, so any handler defined
 * there is dead on arrival.
 *
 * Delegated from document so it keeps working across every drawer re-render.
 */
(function () {
  if (window.__oaGlassDelegated) return;
  window.__oaGlassDelegated = true;

  document.addEventListener('change', function (event) {
    var check = event.target;
    if (!check || !check.hasAttribute || !check.hasAttribute('data-oa-glass-check')) return;

    var root = check.closest('[data-oa-glass]');
    if (!root) return;

    var note = root.querySelector('[data-oa-glass-note]');
    var wanted = check.checked;
    root.classList.add('oa-glass--saving');

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { 'Glass quote requested': wanted ? 'Yes' : '' }
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart update failed');
        if (note) {
          note.textContent = wanted
            ? root.getAttribute('data-oa-glass-done')
            : root.getAttribute('data-oa-glass-ask');
        }
      })
      .catch(function () {
        check.checked = !wanted;
      })
      .then(function () {
        root.classList.remove('oa-glass--saving');
      });
  });
})();
